import React from "react";
import PropTypes from "prop-types";
import MenuItems from "./MenuItems";
import "./LeftMenu.css";

class LeftMenu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      width: '0',
    };
    this.leftMenuRef = React.createRef();
  }

  componentDidMount() {
    this.calculateWidth();
    window.addEventListener('resize', this.calculateWidth);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.calculateWidth);
  }

  calculateWidth = () => {
    if (this.leftMenuRef.current) {
      const newWidth =
        this.leftMenuRef.current.parentElement.offsetWidth +
        this.leftMenuRef.current.offsetWidth -
        this.leftMenuRef.current.clientWidth +
        'px';
      // Update width only if it has changed
      this.setState((prevState) => {
        if (prevState.width !== newWidth) {
          return { width: newWidth };
        }
        return null;
      });
    }
  };

  render() {
    return (
      <div
        className="leftMenu"
        style={{ overflowY: 'hidden', overflowX: 'hidden' }}
      >
        <div
          ref={this.leftMenuRef}
          className="leftMenu"
          style={{
            top: '75px',
            paddingBottom: '100px',
            width: this.state.width,
            overflowX: 'hidden',
          }}
        >
          <MenuItems routes={this.props.routes} userRoutes={this.props.userRoutes} isDrawer={this.props.isDrawer} closeDrawer={this.props.closeDrawer} />

        </div>
      </div>
    );
  }
}

LeftMenu.propTypes = {
  routes: PropTypes.array,
  userRoutes: PropTypes.array,
  isDrawer: PropTypes.bool,
  closeDrawer: PropTypes.func,
  logout: PropTypes.func,
};

LeftMenu.defaultProps = {
  routes: [],
  userRoutes: [],
  isDrawer: false,
  closeDrawer: () => {},
  logout: () => {},
};


export default LeftMenu;